import React, { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { ChevronDown } from 'lucide-react'

function Dropdown({ label, options, value, onChange, colorMap = {} }) {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <div className="relative">
            <button 
                onClick={() => setIsOpen(!isOpen)}
                className="flex items-center gap-1 hover:text-white"
            >
                {label} <ChevronDown className="w-3 h-3" />
            </button>
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        className="absolute left-0 top-full mt-2 bg-customDark rounded-lg shadow-xl z-50 overflow-hidden min-w-[130px]"
                    >
                        {options.map((option) => (
                            <button
                                key={option}
                                onClick={() => { onChange(option); setIsOpen(false) }}
                                className={`block w-full px-4 py-2 text-left text-sm hover:bg-customGray ${
                                    colorMap[option] || 'text-white'
                                } ${value === option ? 'bg-customGold' : ''}`}
                            >
                                {option}
                            </button>
                        ))}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    )
}

export default Dropdown